import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareSecurityNextGenRoute: InvariantJiraRoute = {
	name: 'software-security',
	path: '/jira/software/projects/:projectKey/security',
};
